import { render, staticRenderFns } from "./hcharts.vue?vue&type=template&id=8a8b27ac&scoped=true&"
import script from "./hcharts.vue?vue&type=script&lang=js&"
export * from "./hcharts.vue?vue&type=script&lang=js&"
import style0 from "./hcharts.vue?vue&type=style&index=0&id=8a8b27ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8b27ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a8b27ac')) {
      api.createRecord('8a8b27ac', component.options)
    } else {
      api.reload('8a8b27ac', component.options)
    }
    module.hot.accept("./hcharts.vue?vue&type=template&id=8a8b27ac&scoped=true&", function () {
      api.rerender('8a8b27ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pricing/hcharts.vue"
export default component.exports